import React from "react";

export default function CrossPlatformIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#231F20">
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="M18 47.5h8.75L24.125 58H22c-.552 0-1 .448-1 1s.448 1 1 1h20c.552 0 1-.448 1-1s-.448-1-1-1h-2.125L37.25 47.5H46v-2H18v2zM62 0H2C.896 0 0 .896 0 2v43.5c0 1.104.896 2 2 2h4v-2H2V2h60v20h2V2c0-1.104-.896-2-2-2"
                    transform="translate(-1380 -2618) translate(1281 2598) translate(54 20) translate(45) translate(4 10)"
                  />
                  <path
                    d="M70 54H48V24h22v30zm-11 4c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm11-36H48c-1.104 0-2 .896-2 2v34c0 1.104.896 2 2 2h22c1.104 0 2-.896 2-2V24c0-1.104-.896-2-2-2zM17 47.5V56H7V40h10v7.5zM12 59c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm5-21H7c-1.104 0-2 .896-2 2v18c0 1.104.896 2 2 2h10c1.104 0 2-.896 2-2V40c0-1.104-.896-2-2-2z"
                    transform="translate(-1380 -2618) translate(1281 2598) translate(54 20) translate(45) translate(4 10)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
